import fetch from '../../utils/fetch';

const mapLocationToApiValues = values => {
  const { __typename, contract, isRemovable, status, parentLocation, ...cleanedValues } = values;
  const result = { ...cleanedValues };
  
  if (parentLocation && parentLocation.referenceId) {
    result.parentReferenceId = parentLocation.referenceId;
  }
  
  return result;
};

export const addLocation = (location, contractId) => (dispatch, getState) =>
  fetch('api/location', {
    method: 'POST',
    body: JSON.stringify({
      item: mapLocationToApiValues(location),
      contractId,
    }),
  })(dispatch, getState).then(res => res);

export const updateLocation = (values) => (dispatch, getState) => {
  return fetch(`api/location/${values.id}`, {
    method: 'PUT',
    body: JSON.stringify({
      contractId: values.contract.id,
      item: mapLocationToApiValues(values),
    }),
  })(dispatch, getState).then(res => res);
};
